import ErrorBoundary from 'shared/components/ErrorBoundary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion  from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Rating from './Rating';
import styles from './styles.css';

const muiStyles = {
	productReviewsPanel: {
		overflowX: 'hidden',
		fontFamily: 'Open Sans',
		width: '100%',
	},

	productReviewsReview: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: 'row',
		marginBottom: '0.5em',
		borderBottom: '1px solid',
		paddingBottom: '1.5em',
	},

	productReviewsReviewDetails: {
		flexDirection: 'column',
	},

	productReviewsReviewText: {
		width: '60%',
	},

	productReviewsReviewP: {
		margin: '0em',
	},
};

/**
 * Handle display of product reviews
 * @param {React props} productReviews
 */
const ProductReviews = ({ productReviews, classes }) => (
	<ErrorBoundary>
		<div className={styles['product-expandable-spacer']}>
			<Accordion>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="subtitle2">Reviews</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<div className={classes.productReviewsPanel}>
						{productReviews.map(review => (
							<div className={classes.productReviewsReview} key={review.Id}>
								<div className={classes.productReviewsReviewDetails}>
									<Rating productReviewRating={review.Rating} />
									<p className={classes.productReviewsReviewP}>{review.CustomerName}</p>
									<p className={classes.productReviewsReviewP}>{review.WrittenOnStr}</p>
								</div>
								<div className={classes.productReviewsReviewText}>
									<b>{review.Title}</b>
									<p className={classes.productReviewsReviewP}>{review.ReviewText}</p>
								</div>
							</div>
						))}
					</div>
				</AccordionDetails>
			</Accordion>
		</div>
	</ErrorBoundary>
);

ProductReviews.propTypes = {
	productReviews: PropTypes.instanceOf(Object).isRequired,
	classes: PropTypes.shape({
		productReviewsPanel: PropTypes.string,
		productReviewsReview: PropTypes.string,
		productReviewsReviewDetails: PropTypes.string,
		productReviewsReviewText: PropTypes.string,
	}).isRequired,
};

export default withStyles(muiStyles, { name: 'ProductReviews' })(ProductReviews);
